import React from 'react';
import { useNavigate } from 'react-router-dom';
import book from '../../assets/icons/book.svg';
import explore from '../../assets/icons/explore.svg';
import calendar from '../../assets/icons/calendar.svg';
import map from '../../assets/icons/map.svg';
import home from '../../assets/icons/home.svg';

const BottomNav = () => {
    const navigate = useNavigate();
  
    return (
      <nav className="bottomNav">
        <button onClick={() => navigate('/Home')}>
        <img src={home} alt="home icon" />
          <p>Home</p>
        </button>
  
        <button onClick={() => navigate('/Explore')}>
        <img src={explore} alt="compass icon" />
          <p>Explore</p>
        </button>
  
        <button onClick={() => navigate('/Map')}>
        <img src={map} alt="map icon" />
          <p>Map</p>
        </button>
  
        <button onClick={() => navigate('/Events')}>
        <img src={calendar} alt="calendar icon" />
          <p>Events</p>
        </button>
  
        <button onClick={() => navigate('/Book')}>
        <img src={book} alt="ticket icon" />
          <p>Book</p>
        </button>
      </nav>
    );
}
 
export default BottomNav;